import { getStickyHeaderHeight } from "@/shared/utils/getStickyHeaderHeight"

export const HOSPITAL_TABS_ANCHOR_ID = "hospital-tabs-anchor"
export const HOSPITAL_TABS_ID = "hospital-tabs"

export function getHospitalTabsAnchorElement() {
  return document.getElementById(HOSPITAL_TABS_ANCHOR_ID) ?? document.getElementById(HOSPITAL_TABS_ID)
}

export function getHospitalTabsScrollTop() {
  const anchor = getHospitalTabsAnchorElement()
  if (!anchor) return null

  return anchor.getBoundingClientRect().top + window.scrollY - getStickyHeaderHeight()
}

export function scrollToHospitalTabs(options?: { behavior?: ScrollBehavior }) {
  const scrollTop = getHospitalTabsScrollTop()
  if (scrollTop === null) return

  window.scrollTo({ top: scrollTop, behavior: options?.behavior ?? "smooth" })
}
